import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import * as breakpoints from '../../../data/breakpoints';
import NoResultsMessage from '../../Global/Messages/NoResultsMessage';
import LicenceeTableRow from './LicenceeTableRow';

const LicenceeTable = ({ loading, licences, onLicenceChange, onDeleteClick, editingLicencees }) => {
  function checkIfEditing(currentLicenceeId) {
    for (let i = 0; i <= editingLicencees.length; i++) {
      if (editingLicencees[i] === currentLicenceeId) {
        return true;
      }
    }
    return false;
  }

  let tableBody;
  const noResultsOrLoadingTableBody = (
    <tr><td colSpan="4" className="p-a-0">
      <NoResultsMessage
        title="You haven't allocated any licences yet"
        text="Allocating licences allows you to upgrade other users of The Coaching Manual without them having to pay themselves. Click the 'Allocate licence' button above to get started."
        loading={loading}
      />
    </td></tr>
  );

  // Bit of a weird if statement but needs to be in this order to allow various loading states when paging
  if (loading) {
    tableBody = noResultsOrLoadingTableBody;
  } else if (licences.allocated.length > 0) {
    tableBody = (
      licences.allocated.map(licencee => (
        <LicenceeTableRow
          key={licencee.id}
          licencee={licencee}
          onLicenceChange={onLicenceChange}
          onDeleteClick={onDeleteClick}
          loading={checkIfEditing(licencee.id)}
        />
      ))
    );
  } else {
    tableBody = noResultsOrLoadingTableBody;
  }

  const remainingText = (
    <MediaQuery minWidth={breakpoints.SMALL}>
      {(matches) => {
        if (matches) {
          return <span className="fw-normal">remaining</span>;
        }
        return null;
      }}
    </MediaQuery>
  );

  return (
    <table className="licence-table table w-100 m-b-3">
      <thead className="thead">
        <tr>
          <th>
            Licence holders
            {'total-licences' in licences.information &&
              ` (${licences.information['total-licences'].attributes.used})`
            }
          </th>
          <th>
            Standard
            {'standard-licences' in licences.information &&
              <p className="color-grey m-b-0">
                {licences.information['standard-licences'].attributes.free} / {licences.information['standard-licences'].attributes.total} {remainingText}
              </p>
            }
          </th>
          <th>
            Premium
            {'premium-licences' in licences.information &&
              <p className="color-grey m-b-0">
                {licences.information['premium-licences'].attributes.free} / {licences.information['premium-licences'].attributes.total} {remainingText}
              </p>
            }
          </th>
          <MediaQuery minWidth={breakpoints.SMALL}>
            {(matches) => {
              if (matches) {
                return <th>Remove</th>;
              }
              return <th />;
            }}
          </MediaQuery>
        </tr>
      </thead>

      <tbody className="tbody">{tableBody}</tbody>
    </table>
  );
};

LicenceeTable.propTypes = {
  loading: PropTypes.bool.isRequired,
  licences: PropTypes.object.isRequired,
  onLicenceChange: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  editingLicencees: PropTypes.array.isRequired,
};

export default LicenceeTable;



// WEBPACK FOOTER //
// ./library/app/components/Account/LicenceManager/LicenceeTable.js